import { Search, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SearchIdeas } from "@/components/SearchIdeas";

export function ListingSearch({ value, onChange, onDeepSearch, onPick, listings, city }) {
  const submit = (e) => {
    e.preventDefault();
    if (value.trim().length >= 2) onDeepSearch(value.trim());
  };
  return (
    <form onSubmit={submit} data-testid="listing-search-form"
      className="mt-6 flex items-center gap-2 max-w-2xl rounded-2xl bg-[#151C2C] border border-[#26334D] focus-within:border-[#00E5A3] transition-colors p-1.5 pl-4">
      <Search className="h-4 w-4 text-[#00E5A3] shrink-0" />
      <input data-testid="listing-search-input" value={value} onChange={(e) => onChange(e.target.value)} maxLength={80}
        placeholder="Search anything — escape rooms, karaoke, sushi, go-karts…"
        className="flex-1 min-w-0 bg-transparent outline-none text-sm py-1.5 placeholder:text-slate-500" />
      {value && (
        <button type="button" data-testid="listing-search-clear" onClick={() => onChange("")} aria-label="Clear" className="text-slate-400 hover:text-white"><X className="h-4 w-4" /></button>
      )}
      <SearchIdeas onPick={onPick} listings={listings} city={city} />
      <Button data-testid="listing-search-submit" type="submit" disabled={value.trim().length < 2}
        className="h-9 rounded-xl bg-[#00E5A3] hover:bg-[#00C98F] text-[#0B0F19] font-semibold">Search</Button>
    </form>
  );
}
